<div class="experience-container">
    <mat-toolbar class="grow-toolbar px-0 mb-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="sidebar-btn" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button (click)="sidenavService.toggle()" *ngIf="!(screenWidth | isLargeScreen)">
                <mat-icon>apps</mat-icon>
            </button>
            <div fxLayout="row" fxLayoutAlign="start center">
                <button mat-icon-button class="mr-4" (click)="goBack()">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                <h2>{{ experience.name }}</h2>
            </div>
        </div>
    </mat-toolbar>
    <div class="experience">
        <mat-card
            appearance="outlined"
            class="experience-card mb-24 p-20 mat-elevation-z0"
            *ngFor="let category of categories"
            [routerLink]="isCategoryDisabled(category) ? null : category.url"
            [class.disabled]="isCategoryDisabled(category)"
            [matTooltip]="'GENERAL.MESSAGE.NO_PERMISSION' | translate"
            [matTooltipDisabled]="!isCategoryDisabled(category)"
        >
            <mat-card-header class="experience-card-header">
                <div
                    mat-card-avatar
                    class="experience-card-image"
                    *ngIf="category.image; else categoryIcon"
                    [style.background-image]="'url(' + category.image.smallUrl + ')'"
                ></div>
                <ng-template #categoryIcon>
                    <div mat-card-avatar class="experience-card-icon-container" [ngClass]="category.cls">
                        <div class="experience-card-icon"></div>
                    </div>
                </ng-template>
            </mat-card-header>
            <mat-card-content class="experience-card-content">
                <div>
                    <mat-card-title>{{ category.name }}</mat-card-title>
                    <p class="mt-0 mb-4 text-xs">{{ category.description | translate }}</p>
                    <p class="text-gray-400 text-xs mt-0" *ngIf="category.widgets">{{ 'ENGAGE.AUDIENCE.LABELS.WIDGETS_COUNT' | translate: { total: category.widgets } }}</p>
                    <p class="text-gray-400 text-xs mt-0" *ngIf="category.members">{{ category.members }} {{ 'ENGAGE.MEMBER.TITLE.PLURAL' | translate }}</p>
                </div>
                <div class="content-card-actions">
                    <a fxLayout="row" fxLayoutAlign="start center" [routerLink]="isCategoryDisabled(category) ? null : category.url">{{ category.action }}<mat-icon>arrow_right_alt</mat-icon> </a>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
